import { createRoot, hydrateRoot } from "react-dom/client";
import App from "./app/App.tsx";
import { isPrerenderedFor, seedStoresForHydration } from "./app/hydration";
import { installGlobalErrorHandlers, reportError } from "./app/telemetry";
// Self-hosted Figtree, roman + italic (replaces the Google Fonts <link>).
// Imported from JS rather than tailwind.css so Vite rebases the font URLs.
import "@fontsource-variable/figtree/wght.css";
import "@fontsource-variable/figtree/wght-italic.css";
import "./styles/tailwind.css";

// Capture uncaught errors/rejections that happen outside any React
// ErrorBoundary (event handlers, timers, fire-and-forget async code).
installGlobalErrorHandlers();

const container = document.getElementById("root")!;

// Public pages are prerendered at build time (scripts/prerender.mts) and
// carry data-np-prerendered="<route>". Hydrate only when that markup is for
// this very URL; anything else (the spa.html shell for /app, /callback, 404s)
// gets a fresh client render.
if (isPrerenderedFor(container, window.location.pathname)) {
  seedStoresForHydration();
  hydrateRoot(container, <App />, {
    onRecoverableError(error, info) {
      reportError(error, { source: "hydration", componentStack: info.componentStack });
    },
  });
} else {
  container.replaceChildren();
  createRoot(container).render(<App />);
}
